import { useEffect, useState } from "react";
import { apiJson } from "../../utils/api";
import useSeo from "../../hooks/useSeo";

const GROUPS = [
  { key: "official", title: "🏛️ 民政局登记点", legal: true },
  { key: "special", title: "🏦 银行/景区等特色登记点", legal: "maybe" },
  { key: "venues", title: "💒 婚礼/仪式场地", legal: false },
  { key: "romantic", title: "🌅 求婚圣地", legal: false },
  { key: "vendors", title: "🏨 附近婚礼/摄影/婚宴/蜜月", legal: false },
];

export default function RomanticMap() {
  const [data, setData] = useState({ official: [], special: [], venues: [], romantic: [] });

  useSeo({
    title: "浪漫领证地图",
    metaDescription: "区分正式婚姻登记机关与婚礼仪式场地，避免把景区误当成民政局。",
    path: "/travel/romantic-map",
  });

  useEffect(() => {
    apiJson("/api/travel/romantic-map").then(({ data: d }) => setData(d));
  }, []);

  return (
    <div className="space-y-8">
      <h1 className="text-3xl font-extrabold">浪漫领证地图</h1>
      <p className="text-sm text-amber-800 bg-amber-50 rounded-xl p-3">
        正式婚姻登记只能在依法具有权限、且标注「可办理」的机关进行。景区、酒店、海边只能做求婚/婚礼/模拟领证。
      </p>
      {GROUPS.map((group) => (
        <section key={group.key}>
          <h2 className="font-bold text-lg mb-3">{group.title}</h2>
          <div className="grid md:grid-cols-2 gap-3">
            {(data[group.key] || []).map((item) => (
              <article key={`${group.key}-${item.id}`} className="bg-white rounded-2xl p-4 text-sm">
                <div className="flex justify-between gap-2">
                  <h3 className="font-bold">{item.name}</h3>
                  <span className={item.can_legal_register ? "text-emerald-700" : "text-gray-500"}>
                    {item.can_legal_register ? "可正式登记" : "仅仪式"}
                  </span>
                </div>
                <p className="text-gray-500 mt-1">{item.city} {item.address || ""}</p>
                <p className="text-rose-700 mt-1">{item.legal_label}</p>
              </article>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
